// eslint-disable-next-line import/no-unresolved
import '@cirkay-eng/cirkay-components/mobile-pass';
// eslint-disable-next-line import/no-unresolved
import '@cirkay-eng/cirkay-components/fan-pass-claim';
// eslint-disable-next-line import/no-unresolved
import '@cirkay-eng/cirkay-components/fan-pass-unlock';
// @ts-ignore
import { LoginEvents } from '@cirkay-eng/cirkay-components/login-events';

document.addEventListener(LoginEvents.Submit, (event) => {
	try {
		if (
			event.detail &&
			Object.keys(event.detail).length > 1 &&
			event.detail['fp-maillist'] === 'fp-maillist' &&
			cirkay_fan_pass.sign_up_ajax_enabled === '1'
		) {
			const formData = event.detail;
			formData.action = 'fp_mail_signup';
			formData.nonce = cirkay_fan_pass.nonces.mail_signup;
			Object.keys(event.detail).forEach((key) => {
				formData[key] = event.detail[key];
			});
			const requestData = formData;
			// @ts-ignore
			fetch(cirkay_fan_pass.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams(requestData).toString(),
			})
				.then((response) => {
					if (response.ok) {
						return response.json();
					}
					return Promise.reject(response);
				})
				.then((data) => {
					if (data.success) {
						// Handle successful signup
						//console.log('Signup successful:', data);
					} else {
						// Handle error
						//console.error('Signup failed:', data.message);
					}
				})
				.catch((error) => {
					console.error('Error', error);
				});
		}
	} catch (error) {
		console.error(error);
	}
});
